module.exports = __webpack_public_path__ + "img/banner.c4ff26a8.jpg";